/**
 *  TECH-7835: display error on the page instead of only after the redirect.
 * @param {DOMElement} $eventTarget The signup form
 * @param {Boolean} onPageOne Flag indicating if we are validating a form on signup page 1
 */
function validateSignupFormCheckboxes($eventTarget, onPageOne) {
  // remove any previous error messages
  $eventTarget.find('.form-error__message').remove();

  // string that will be used to grab checkbox that's inside form
  // can't use id as they are specfic to each form based on location
  const userConsentSelector = 'input[name="user_consent"]';
  // verify if terms of use + privacy policy box is selected
  const $termsError = !($eventTarget.find(userConsentSelector).prop('checked'));

  // pub checkboxes are identified by different classes depending on if we are
  // on signup page 1 vs. everywhere else
  const signupSelector = (onPageOne) ? '.checkbox input' : '.signup-list input';
  // verify if multiple pubs exist and if any are checked
  const $isMultiPubSignUp = $eventTarget.find(signupSelector).not(userConsentSelector).length > 0;
  const $isAtLeastOneNewsletterSelected = $eventTarget.find('input:checkbox:checked').not(userConsentSelector).length > 0;
  const isValidNewsletterSelection = $isMultiPubSignUp ? $isAtLeastOneNewsletterSelected : true;
  const signupError = !(isValidNewsletterSelection);

  // error logic
  /* eslint-disable */
  if ($termsError && signupError) {
    return 'You must select at least one newsletter and agree to our Terms of Use and Privacy Policy.';
  } else if ($termsError) {
    return 'You must agree to our Terms of Use and Privacy Policy.';
  } else if (signupError) {
    return 'You must select at least one newsletter.';
  }
  return null;
}
/* eslint-enable */

// Used for displaying email errors in all locations except signup page 1
function displayNonPage1EmailError($eventTarget, message) {
  $eventTarget.find('.email-input').append(`<p class="form-error__message"> ${message} </p>`);
}

/**
* Displays the error messages from validateSignupFormCheckboxes and, if on
* signup page 1, any email errors
* @param {DOMElement} $eventTarget The signup form
* @param {Boolean} onPageOne Flag indicating if we are displaying errors on signup page 1
* @param {Array[String]} messages Error messages to be displayed
*/
function displaySignupErrors($eventTarget, onPageOne, ...messages) {
  if (onPageOne) {
    const $errorAnchor = $eventTarget.find('.signup-button-wrapper');
    for (let i = 0; i < messages.length; i += 1) {
      $errorAnchor.append(`<p class="signup-form-error-message form-error__message"> ${messages[i]} </p>`);
    }
  } else {
    $eventTarget.find('.email-input').prepend(`<p class="form-error__message"> ${messages[0]} </p>`);
  }
}

/**
 * This event is dispatched on a successful sign up after validaion.
 * We have listeners for this event in sendEmailToLytics.js and gtmEvents.js
 */
const gtmSignup = new Event('triggerSignupOnGTM');

$(document).ready(() => {
  // Error message on signup page 1, footer feedback, and right sidebar
  // signup form. This is meant to keep people who enter invalid emails
  // in Safari (where HTML5 email validation doesn't work) from being sent to
  // /feedback or /signup from whatever page they *were* on because of
  // Django form validation on /feedback and /signup catching the bad email.
  // It also helps us track Facebook leads on form submit by triggering a custom event.
  $('.js-form-email-validate').submit(function(event) {
    const onSignupPage1 = $(this).find('.signup-button-wrapper').length > 0;
    const value = $(this).find('input[type=email]').val();

    let invalidEmailMessage;
    if (!value || value.indexOf('@') < 0 || value.indexOf('.') < 0) { // "if form is invalid"
      invalidEmailMessage = 'Please enter a valid email.';
      $(this).find('.form-error__message').remove();
      if (onSignupPage1) {
        invalidEmailMessage = 'Please enter a valid e-mail address.';
      } else {
        event.preventDefault();
        $(this).find('input[type=email]').addClass('form-error__highlight');
        displayNonPage1EmailError($(this), invalidEmailMessage);
        return false;
      }
    }

    const isSignupForm = $(this).filter('[name="signup"]').length > 0;
    if (isSignupForm) {
      const errorMessage = validateSignupFormCheckboxes($(this), onSignupPage1);
      if (errorMessage || invalidEmailMessage) {
        event.preventDefault();
        if (errorMessage && invalidEmailMessage) {
          displaySignupErrors($(this), onSignupPage1, errorMessage, invalidEmailMessage);
        } else if (invalidEmailMessage) {
          displaySignupErrors($(this), onSignupPage1, invalidEmailMessage);
        } else if (errorMessage) {
          displaySignupErrors($(this), onSignupPage1, errorMessage);
        }
        return false;
      }
    }
    this.dispatchEvent(gtmSignup);
    return true;
  });

  // inline signup
  // opens demographics page in another window
  $('.inline-signup form').attr('target', '_blank');
  // TODO: this variable is repeated, don't love it
  $('.inline-signup .js-form-email-validate').submit(function(event) {
    const value = $(this).find('input[type=email]').val();
    const $eventTarget = $(event.target);
    const errorMessage = validateSignupFormCheckboxes($eventTarget, false);
    const emailIsValid = value || value.indexOf('@') > 0 || value.indexOf('.') > 0;
    // if email is not valid
    if (!(emailIsValid)) {
      event.preventDefault();
      return false;
    }
    // if form checkboxes not properly filled out
    if (errorMessage) {
      event.preventDefault();
      displaySignupErrors($eventTarget, false, errorMessage);
      return false;
    }
    $('.inline-signup p, .inline-signup .email-input, .inline-signup .signup-list, .inline-signup .button').hide();
    $('.inline-signup form').append('<p>Thanks! Look out for an email from us soon.</p>');
    this.dispatchEvent(gtmSignup);
    return true;
  });
});
